var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorderDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1930.302,
    height: 130,
    viewBox: "0 0 1930.302 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Uni\\xF3n_14",
    x: 0,
    y: 0,
    width: 1932.302,
    height: 127,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    transform: "translate(3914.898 -4075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(-3899.898 4080)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -5)",
    filter: "url(#Uni\\xF3n_14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_14-2",
    "data-name": "Uni\\xF3n 14",
    d: "M0,97V57.725H57.358C157.986,43.634,265.209.107,351.03.107c135.645,0,258.893,49.551,372.312,50.549,77.552.681,152.779-12.317,223-25.315C1018.381,12,1085.15-1.333,1143.745.107c198.577,4.879,320.948,44.252,425.9,51.356,24.907,1.686,67.775-6.344,108.322-14.374,39.01-7.726,75.871-15.451,92.525-14.524,55.3,3.074,91.522,12.542,110.382,20.151,17.492,7.057,22.562,16.262,17.652,19.354,2.6,2.91-1.322,3.352-6.7,2.9V97Z",
    transform: "translate(15 5)",
    fill: "rgba(46,19,92,0.99)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M0,0H1899.862V37L0,19.026Z",
    transform: "translate(0 60)",
    fill: "#2e135c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderDark);
export default __webpack_public_path__ + "static/media/borderDark.959ca11e317dd25c9638708d117ad56e.svg";
export { ForwardRef as ReactComponent };